import { graphql } from '@mews-commander/guest-profile';

export const ClassificationFieldsFragment = graphql(`
    fragment ClassificationFields on GuestProfileClassifications {
        airline
        blacklist
        cashlist
        disabledPerson
        friendOrFamily
        healthCompliant
        important
        inRoom
        loyaltyProgram
        media
        military
        paymasterAccount
        previousComplaint
        problematic
        returning
        staff
        student
        topManagement
        veryImportant
        waitingForRoom
    }
`);

export const ReservationSummaryFieldsFragment = graphql(`
    fragment ReservationSummaryFields on ReservationSummary {
        accountState
        endUtc
        groupName
        id
        serviceId
        number
        reservationState
        serviceOrderState
        startLocalTime
        endLocalTime
        startUtc
        timeState
        options {
            allCompanionsCheckedIn
            anyCompanionCheckedIn
            ownerCheckedIn
            ownerCheckedOut
            skipCleaning
        }
        resource {
            id
            name
            state
        }
    }
`);

export const LoyaltyMembershipSummaryFieldsFragment = graphql(`
    fragment LoyaltyMembershipSummaryFields on Membership {
        code
        createdUtc
        id
        isPrimary
        points
        state
        updatedUtc
        program {
            ...LoyaltyProgramFields
        }
        tier {
            ...LoyaltyTierFields
        }
    }
`);
